import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonSpinner,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import { home, sadOutline } from 'ionicons/icons'
import React, { useEffect, useState } from 'react'
import { PinField } from 'react-pin-field'
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import Note from "../components/note"
import { PrivacyModal } from '../components/privacy.modal'
import { getItem, setItem } from '../lib/storage'
import { State } from '../store'
import { addNotification, addNotificationType } from '../store/notification'
import { addMessage, addMessageType } from '../store/peter'
import { decode, decodeType, loadById, loadByIdType } from "../store/scan"

interface StateProps {
  encoded?: string
  error?: string
  lastScan?: number
}

interface DispatchProps {
  loadById: loadByIdType
  decode: decodeType
  addNotification: addNotificationType
  addMessage: addMessageType
}

type Props = RouteComponentProps<{id: string}> & StateProps & DispatchProps

const Start: React.FC<Props> = (props) => {
  const [pin, setPin] = React.useState('');
  const pinRef = React.createRef<HTMLInputElement[]>()
  const [showLoading, setShowLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [privacyRead, setPrivacyRead] = useState(false);

  React.useEffect(() => {
    void props.loadById(props.match.params.id);

    getItem(`key-${props.match.params.id}`)
      .then((found) => {
        if (found) {
          return
        }

        console.log('key not set stored')

        setItem(`key-${props.match.params.id}`, window.location.hash.replace('#', ''))
          .catch(() => {
            console.error('failed to cache encryption key')
          })
      })
  }, [ props.match.params.id ])

  const check = async () => {
    if (!privacyRead) {
      props.addNotification({
        color: 'warning',
        message: 'Zustimmung fehlt',
      })

      return
    }

    if (pin.length !== 5) {
      props.addNotification({
        color: 'warning',
        message: 'Pin ist unvollständig',
      })

      return
    }

    const key = await getItem(`key-${props.match.params.id}`)

    if (!key) {
      props.addNotification({
        color: 'warning',
        message: 'Key nicht gefunden',
      })
      return;
    }

    setShowLoading(true);

    try {
      await props.decode(key, pin);

      props.history.push({ pathname: '/person' })
    } catch (e) {
      console.error(e)
      props.addNotification({
        color: 'danger',
        message: 'Falscher Pin',
      })
    }

    setShowLoading(false);
  }

  useEffect(() => {
    if (pinRef.current && pin === '') {
      setTimeout(() => {
        pinRef.current && pinRef.current[0].focus()
      }, 500)
    }
  }, [confirmed, pin, pinRef.current])

  if (!props.encoded && !props.error) {
    return (
      <IonPage style={{alignItems: 'center', justifyContent: 'center'}}>
        <IonSpinner />
      </IonPage>
    )
  }

  if (props.error) {
    return (
      <IonPage style={{alignItems: 'center', justifyContent: 'center', padding: 16}}>
        <IonIcon
          icon={sadOutline}
          style={{
            fontSize: 160,
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: 32,
          }}
        />
        <Note>
          <h2>Oh, hier ist etwas schief gegangen</h2>

          Bitte versuchen sie es erneut.

        </Note>
        <IonButton color="danger" expand={'block'} onClick={() => props.history.push({ pathname: '/home' })}>Zum Start</IonButton>
      </IonPage>
    )
  }

  let content;

  if (confirmed) {
    content = (
      <>
        <IonContent className="ion-padding">
          <form onSubmit={(e) => {
            e.preventDefault()
            check()
          }}>
            <IonLoading
              isOpen={showLoading}
              onDidDismiss={() => setShowLoading(false)}
              message={'Prüfe Pin...'}
            />

            {props.lastScan && (
              <Note type={"warning"}>
                Sie haben zuvor einen QR Code gescannt. Wenn sie nun fortfahren werden die zuvor eingegebenen Daten verworfen.
              </Note>
            )}

            <div className={'pin-label'}>Bitte gib den Pin über dem QR Code ein</div>
            <div className="pin-container">
              <PinField
                style={{
                  width: Math.max(20, Math.min(Math.floor((window.innerWidth - 32 - 4 * 10) / 5), 60)),
                  height: 60,
                  fontSize: 30,
                }}
                ref={pinRef}
                type={'number'}
                length={5}
                onChange={v => setPin(v)}
              />
            </div>

            <Note>
              Um fortzufahren benötigen wir ihr Einverständnis zur automatisierten Datenverarbeitung.
              <br />
              <p style={{
                color: 'rgba(0,0,0,0.5)',
                fontStyle: 'italic',
                fontSize: '80%'
              }}>
                Daten für die Erstellung des Angebots werden erst nach einer erneuten expliziten Zustimmung übertragen.
              </p>
            </Note>

            <PrivacyModal onConfirmRead={() => setPrivacyRead(true)} />

            <IonItem lines={'none'}>
              <IonLabel>Ich stimme der Verarbeitung zu</IonLabel>
              <IonCheckbox checked={privacyRead} onIonChange={e => setPrivacyRead(e.detail.checked)} />
            </IonItem>
          </form>
        </IonContent>

        <IonFooter>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => setConfirmed(false)}>
                Zurück
              </IonButton>
            </IonButtons>
            <IonButton
              color="primary"
              expand={'block'}
              type={'submit'}
              onClick={check}
            >
              Weiter
            </IonButton>
          </IonToolbar>
        </IonFooter>
      </>
    )
  } else {
    content = (
      <IonContent className="ion-padding">
        <Note>
          Welche Beratung benötigen sie?
          <br />
          <p style={{
            color: 'rgba(0,0,0,0.5)',
            fontStyle: 'italic',
            fontSize: '80%'
          }}>
            Bei der umfassenden Beratung meldet sich ein Mitarbeiter bei ihnen!
          </p>
        </Note>
        <IonButton
          color="primary"
          expand={'block'}
          size={'large'}
          onClick={() => {
            props.addMessage({
              animation: 'pointLeft',
              message: 'Über dem QR Code finden sie den Pin!'
            })

            setConfirmed(true)
          }}
          style={{
            marginBottom: 20,
          }}
        >
          weiter für Eigenheim
        </IonButton>
        <div
          style={{
            marginTop: 60,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <IonButton
            color="tertiary"
            onClick={() => props.history.push(`/contact/${props.match.params.id}`)}
          >
            Umfassende Beratung
          </IonButton>
        </div>
      </IonContent>
    )
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/home' })}>
              <IonIcon slot="icon-only" icon={home} />
            </IonButton>
          </IonButtons>
          <IonTitle>Eigenheim Versicherung</IonTitle>
        </IonToolbar>
      </IonHeader>
      {content}
    </IonPage>
  );
};

export default connect<StateProps, DispatchProps, unknown, State>(
  ({scan, quote}) => ({
    lastScan: quote.created,
    encoded: scan.encoded,
    error: scan.error,
  }),
  {
    loadById,
    decode,
    addNotification,
    addMessage
  }
)(Start);
